import { useEffect, useState } from "react";
import { App, Button, Flex, notification } from "antd";

import DownloadIcon from "@/icons/DownloadIcon";
import ExportTasksModal from "@/components/modals/ExportTasksModal";
import routes from "@/routes";
import { TASK_EXPORT_ENABLED } from "@/constants/tasks";
import { getPluralizedWord } from "@/utils";

const TaskExportActions = ({
  selectedTasks = [],
  onClear,
  isAdmins = false,
  justify = "flex-end",
}) => {
  const { message } = App.useApp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleExport = (file = {}) => {
    setIsModalOpen(false);

    if (!file.uuid) {
      message.success("Экспорт задач запущен");
      return;
    }

    const link = document.createElement("a");
    link.href = `/api/file/download?uuid=${file.uuid}`;
    link.download = file.original_name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    notification.success({
      message: "Экспорт успешно завершен",
      duration: 10,
      showProgress: true,
      pauseOnHover: true,
      style: {
        width: 480,
      },
      description: file.folder_uuid ? (
        <p>
          Файл сохранен в личную рабочую группу в папку{" "}
          <a href={routes.folder(file.folder_uuid)}>Выгрузка</a>.
        </p>
      ) : null,
    });
  };

  if (!TASK_EXPORT_ENABLED || !selectedTasks.length) return null;

  return (
    <>
      <Flex align="center" justify={justify} gap={8} wrap="wrap">
        {!isMobile && (
          <div>{`Выбрано ${selectedTasks.length} ${getPluralizedWord(
            selectedTasks.length,
            ["задача", "задачи", "задач"],
          )}`}</div>
        )}
        <Button
          type="primary"
          icon={<DownloadIcon />}
          onClick={() => setIsModalOpen(true)}
        >
          {isMobile ? `Скачать ${selectedTasks.length}` : "Скачать"}
        </Button>
      </Flex>

      {isModalOpen && (
        <ExportTasksModal
          tasks={selectedTasks}
          visible={isModalOpen}
          onSave={handleExport}
          onCancel={() => setIsModalOpen(false)}
          onClearAndCancel={() => {
            onClear?.();
            setIsModalOpen(false);
          }}
          isAdmins={isAdmins}
        />
      )}
    </>
  );
};

export default TaskExportActions;
